import React from 'react'

export const HhIcon = () => {
  return (
    <svg
      width="51"
      height="51"
      viewBox="0 0 51 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.75"
        y="0.75"
        width="49.5"
        height="49.5"
        rx="24.75"
        fill="#F3F3F3"
        stroke="#F3F3F3"
        stroke-width="1.5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25.5003 49.5013C38.7543 49.5013 49.5 38.7641 49.5 25.5003C49.5 12.247 38.7549 1.5 25.5003 1.5C12.247 1.5 1.5 12.247 1.5 25.5003C1.5 38.7634 12.247 49.5013 25.5003 49.5013ZM15.0269 22.121V13.8867H11.1328V35.2251H15.0223L15.0269 27.7057C15.0223 26.4441 15.1407 25.4905 15.3788 24.8457C15.6129 24.2001 15.9825 23.7181 16.4972 23.3957C17.0008 23.0759 17.5796 22.9137 18.2238 22.9137C18.7882 22.9137 19.2559 23.0386 19.63 23.291C20.0047 23.5389 20.2644 23.8731 20.4129 24.2995C20.5613 24.7227 20.6313 25.7201 20.6313 27.293V35.2245H24.5274V26.4186C24.5274 25.0713 24.4607 24.0772 24.3272 23.4395C24.1938 22.7979 23.9453 22.2158 23.5777 21.6841C23.2134 21.1582 22.6719 20.724 21.9492 20.3865C21.2284 20.0444 20.424 19.8744 19.5266 19.8744C17.783 19.8744 16.28 20.6272 15.0269 22.121ZM30.3665 22.121V13.8867H26.475V35.2251H30.3665V27.7057C30.3665 26.4441 30.4849 25.4905 30.7184 24.8457C30.9558 24.2001 31.3266 23.7181 31.8341 23.3957C32.3384 23.0759 32.9172 22.9137 33.5627 22.9137C34.1265 22.9137 34.5974 23.0386 34.9689 23.291C35.345 23.5389 35.604 23.8731 35.7524 24.2995C35.9016 24.7227 35.9748 25.7201 35.9748 27.293V35.2245H39.8663V26.4186C39.8663 25.0713 39.7989 24.0772 39.6655 23.4395C39.5314 22.7979 39.2829 22.2158 38.9166 21.6841C38.5536 21.1582 38.0108 20.724 37.2914 20.3865C36.568 20.0444 35.7596 19.8744 34.8649 19.8744C33.1219 19.8744 31.6203 20.6272 30.3665 22.121Z"
        fill="#D54141"
      />
    </svg>
  )
}
